export const DEFAULT_WS_PATH = "/ws/one-chat/";

function browser_websocket_protocol() {
  return window.location.protocol === "https:" ? "wss:" : "ws:";
}

function configured_websocket_base_url() {
  return process.env.VUE_APP_ONE_CHAT_WS_URL || process.env.VUE_APP_WEBSOCKET_BASE_URL || "";
}

export function normalize_websocket_path(path = DEFAULT_WS_PATH) {
  const value = String(path || DEFAULT_WS_PATH).trim();
  if (!value.startsWith("/") || value.startsWith("//")) return DEFAULT_WS_PATH;
  return value;
}

export function build_default_websocket_url(path = DEFAULT_WS_PATH) {
  const normalized_path = normalize_websocket_path(path);
  return `${browser_websocket_protocol()}//${window.location.host}${normalized_path}`;
}

function websocket_protocol_for(protocol) {
  if (protocol === "https:") return "wss:";
  if (protocol === "http:") return "ws:";
  return protocol;
}

function ensure_websocket_path(url, path) {
  if (url.pathname && url.pathname !== "/") return;
  url.pathname = normalize_websocket_path(path);
}

export function websocket_url_from_base(base_url, path = DEFAULT_WS_PATH) {
  const url = new URL(String(base_url || "").trim());
  url.protocol = websocket_protocol_for(url.protocol);
  ensure_websocket_path(url, path);
  return url.toString();
}

export function api_base_websocket_url(path = DEFAULT_WS_PATH) {
  const api_base_url = process.env.VUE_APP_API_BASE_URL || "";
  if (!api_base_url) return "";

  const url = new URL(websocket_url_from_base(api_base_url, path));
  url.pathname = normalize_websocket_path(path);
  url.search = "";
  url.hash = "";
  return url.toString();
}

function preferred_websocket_base_url(path) {
  const configured_url = configured_websocket_base_url();
  if (configured_url) return websocket_url_from_base(configured_url, path);
  return api_base_websocket_url(path) || build_default_websocket_url(path);
}

function assert_websocket_protocol(url) {
  if (!["ws:", "wss:"].includes(url.protocol)) {
    throw new Error("Invalid WebSocket protocol.");
  }
}

export function build_websocket_url(options = {}) {
  const path = normalize_websocket_path(options.path);
  const url = new URL(preferred_websocket_base_url(path));
  assert_websocket_protocol(url);
  if (options.token) url.searchParams.set("token", options.token);
  return url.toString();
}

export function create_request_id(counter) {
  return `${Date.now()}-${counter}`;
}

export function is_success_status(status) {
  return Number(status) >= 200 && Number(status) < 300;
}

export function build_response_error(payload = {}) {
  const message = payload.data?.message || "WebSocket request failed";
  const error = new Error(message);
  error.status = payload.status;
  error.responseJSON = payload.data;
  return error;
}
